import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import {SibebarWrapper, HiddenSidebarWrapper, WrapperForSidebarElements} from './components';

import {changeMobileAdminMenu} from 'redux/actions/admin/system';
import {signOut} from 'redux/actions/auth';

import {loadStaffByUser} from 'redux/actions/portal/institutions';
 
const mapStateToProps = (state) => ({
  menuOpen: state.admin.get('toggleMobileAdminMenu'),
  staff: state.institutions.get('currentUserInstitutions'),
  user: state.auth.get('user')
});

const mapDispatchToProps = (dispatch) => ({
  toggleMobileAdminMenu: () => dispatch(changeMobileAdminMenu()),
  signOut: () => dispatch(signOut()),
  loadStaff: (id, role) => dispatch(loadStaffByUser(id, role))
});

class Sidebar extends Component {

  toggleMenu = () => {
    if (window.innerWidth < 1200) this.props.toggleMobileAdminMenu();
  }

  componentDidMount() {
    if(this.props.cabinet === "Кабінет оператора") {
      this.props.loadStaff(this.props.user.get('id'), "is_operator")
    } else if (this.props.cabinet === "Службовий кабінет"){
      const isAdminInstitution = this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser') ? 'is_admin' : null
      this.props.loadStaff(this.props.user.get('id'), isAdminInstitution)
    } else if (this.props.cabinet === "Кабінет адміністрації") {
      this.props.loadStaff(this.props.user.get('id'), "is_manager_institution")
    } else if (this.props.cabinet === "Реєстратура") {
      this.props.loadStaff(this.props.user.get('id'), "is_registry")
    }

    if (window.innerWidth < 1200 && this.props.menuOpen === false) {
      this.props.toggleMobileAdminMenu();
    }
  }

  render() {
    if (this.props.user === undefined || this.props.staff === undefined) return null

    const cabinet = this.props.match.url.indexOf("cabinet") !== -1;
    const operator = this.props.match.url.indexOf("operator") !== -1;

    return (
      <SibebarWrapper open={this.props.menuOpen}>
        <div>
          {(!this.props.user.get('is_superuser') || operator) && !cabinet && this.props.staff && this.props.staff.get('results') && this.props.staff.get('results').size > 0 &&
            <WrapperForSidebarElements><i className="fa fa-building" aria-hidden="true"></i>
              <span>{this.props.staff.getIn(['results',0, 'institution_data', 'full_title']) || null}</span>
            </WrapperForSidebarElements>
          }

          <WrapperForSidebarElements><i className="fa fa-building" aria-hidden="true"></i><span>{this.props.cabinet}</span></WrapperForSidebarElements>
          <WrapperForSidebarElements><i className="fa fa-user" aria-hidden="true"></i><span>{this.props.user.get('last_name')} {this.props.user.get('first_name')}</span></WrapperForSidebarElements>

          {this.props.routes.map((item, i) => (
            <Link key={i} to={item.path} onClick={this.toggleMenu}>
  						<div><i className={item.icon} aria-hidden="true"></i><span>{item.title}</span></div>
  					</Link>
          ))}
        </div>
        <HiddenSidebarWrapper>
           <Link to="/health-management">Департамент охорони здоров’я</Link>
           <Link to="/news">Новини</Link>
           <Link to="/infocenter">Інфоцентр</Link>
           <Link to="/about">Про Портал</Link>
         </HiddenSidebarWrapper>

      </SibebarWrapper>
    )
  }
}

Sidebar.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));



// WEBPACK FOOTER //
// ./src/components/sidebar/index.js